/**
 * Plausible Analytics helper.
 *
 * The Plausible tracking script is loaded only on the production host
 * (see public/index.html). On preview/dev hosts `window.plausible` is
 * undefined, so this helper becomes a safe no-op and does NOT pollute
 * the production stats with internal traffic.
 *
 * Usage:
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent("form_submit_hero", { property_type: "Kancelář" });
 */
export function trackEvent(name, props) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.plausible === "function") {
      if (props && Object.keys(props).length > 0) {
        window.plausible(name, { props });
      } else {
        window.plausible(name);
      }
    }
    // In dev / preview we just log so we can verify wiring without
    // sending data to Plausible.
    if (
      typeof window !== "undefined" &&
      window.location &&
      !/sanvioro\.cz$/i.test(window.location.hostname || "")
    ) {
      // eslint-disable-next-line no-console
      console.info("[analytics:dev]", name, props || {});
    }
  } catch {
    /* swallow analytics errors */
  }
}
